// extracted by mini-css-extract-plugin
export default {"root":"DataProtection_root__WfLLr","body":"DataProtection_body__xK+x+"};